import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Creators as cancelRequestActions } from '../../../../../../../domain/useCases/procedures/UpdatePhoto/cancelUseCase';
import { Creators as activatePaymentActions } from '../../../../../../../domain/useCases/procedures/certificateType01/activatePaymentUseCase';
import { Creators as downloadDocumentActions } from '../../../../../../../domain/useCases/procedures/certificateType01/downloadDocumentUseCase';
import { Creators as snackbarActions } from '../../../../../../../domain/useCases/snackbarUseCase';
import constants from '../../../../constants';
import routes from '../../../../../../components/Routes/routingMap';
import CertificateType01ProgressView from './CertificateType01ProgressView';
import useSnackbarFields from '../../../scholarships/bse/hooks/useSnackbarFields';

export const downloadCertificate = (base64File: string, fileName: string) => {
  const doc = document.createElement('a');
  doc.href = base64File;
  doc.download = `${fileName}.pdf`;
  doc.click();
};

const CertificateType01ProgressViewController: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { fieldsSnackbar, validateCommon, Types } = useSnackbarFields();
  // states
  const [showModal, setShowModal] = React.useState(false);
  const [showExternal, setShowExternal] = React.useState(false);

  const [showAnulate, setShowAnulate] = React.useState(false);
  // selector
  const { procedure, request, isLoading, isComplete } = useSelector(
    (state: any) => state.procedureStudentStatus
  );

  const { isLoading: isLoadingCancel, isSuccess: isSuccessCancel } =
    useSelector((state: any) => state.cancelUpdatePhoto);
  const {
    isLoading: isLoadingActivatePayment,
    isSuccess: isSuccessActivatePayment
  } = useSelector((state: any) => state.activatePaymentCertificateType01);
  const { base64File } = useSelector((state: any) => state.downloadDocument);

  // handlers
  const handleCloseExternal = () => {
    setShowExternal(false);
  };
  const handlerCloseModal = () => {
    setShowModal(false);
    setShowAnulate(false);
    dispatch(activatePaymentActions.activateCertificateOfStudiesClear());
  };
  const handlerActivatePayment = () => {
    dispatch(
      activatePaymentActions.activateCertificateOfStudies(
        request.procedureId,
        request.id
      )
    );
  };
  const handlerCancelRequest = (
    requestIdParam: number,
    procedureIdParam: number
  ) => {
    dispatch(
      cancelRequestActions.cancelUpdatePhoto(requestIdParam, procedureIdParam)
    );
  };
  const handlerDownload = (key: string) => {
    dispatch(downloadDocumentActions.downloadFile(key));
  };
  const redirect = () => {
    history.push(routes.student.payments.home);
  };

  const handlerOkModal = () => {
    if (isComplete) {
      if (base64File === null) {
        setShowExternal(true);
        return;
      }
      validateCommon(
        Types.success,
        '¡Listo!',
        'Tu archivo está siendo descargado'
      );
      dispatch(snackbarActions.toggleSnackbarOpen());
      downloadCertificate(base64File, request.name);
      return;
    }
    if (showAnulate) {
      handlerCancelRequest(request?.id, request?.procedureId);
      return;
    }
    if (request.status.status === 'CREADO') {
      handlerCloseModal();
      handlerActivatePayment();
      return;
    }
    if (request.status.status === 'PAGO_ACTIVADO') {
      redirect();
    }
  };
  const handlerShowAnulate = () => {
    setShowAnulate(true);
  };
  const handlerStepAction = () => {
    if (request.status.status === 'CREADO') setShowModal(true);
    if (request.status.status === 'PAGO_ACTIVADO') {
      redirect();
    }
  };

  // useEffects
  React.useEffect(() => {
    if (isSuccessCancel) {
      history.push(routes.student.procedures.home);
    }
  }, [isSuccessCancel]);

  React.useEffect(() => {
    if (request?.document) {
      handlerDownload(request?.document);
    }

    if (request?.status?.name === 'Procede') {
      const cetificateFound = constants.categories.certificates.type1List.find(
        (p) => p.procedureId === procedure.id
      );
      history.push(
        `${
          routes.student.procedures.categories.certificates.certificatetype01
            .procedureprogress
        }${'?status=finalizado'}`.replace(
          ':certificatetype01name',
          cetificateFound?.url || procedure
        )
      );
    }
  }, [request]);

  return (
    <CertificateType01ProgressView
      isLoadingCancel={isLoadingCancel}
      procedure={procedure}
      request={request}
      isLoading={isLoading}
      isComplete={isComplete}
      showModal={showModal}
      showAnulate={showAnulate}
      handlerCloseModal={handlerCloseModal}
      handlerStepAction={handlerStepAction}
      handlerShowAnulate={handlerShowAnulate}
      handlerOkModal={handlerOkModal}
      isLoadingActivatePayment={isLoadingActivatePayment}
      isSuccessActivatePayment={isSuccessActivatePayment}
      detail={procedure?.detail}
      selectedProcedureId={procedure?.id}
      handleCloseExternal={handleCloseExternal}
      showExternal={showExternal}
      fieldsSnackbar={fieldsSnackbar}
    />
  );
};

export default CertificateType01ProgressViewController;
